import React from 'react';
import { connect } from 'react-redux';
import LoginForm from './LoginForm';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import * as loginActions from '../../actions/loginActionCreators';
import * as rankLoginActions from '../../actions/rankLoginActionCreators';
import * as studentActions from '../../actions/studentsActionCreators';
import ForgotPasswordModal from './ForgotPasswordModal';
import config from '../../config';
import label from '../../utils/lngEn';
import { Row, Col, Button, Glyphicon } from 'react-bootstrap';

class StudentLoginPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    const redirectRoute = this.props.location.query.next || '/administer/wharton-test';

    this.state = {
      email: '',
      password: '',
      redirectTo: redirectRoute,
      error: null,
      inProgress: false,
      showForgotPassModal: false,
      initialEmail: '',
      loginDisabled: false,
      useSamlLogin: true,
      redirecting: false
    };

    this.login = this.login.bind(this);
    this.openForgotPassModal = this.openForgotPassModal.bind(this);
    this.closeForgotPassModal = this.closeForgotPassModal.bind(this);
  }

  componentWillMount() {
    const { query } = this.props.location;
    const storage = query.viewAs === 'emulate' ? sessionStorage : localStorage;
    if (query.viewAs === 'emulate') {storage.setItem('emulating', true)}
    const runName = storage.getItem('run');
    const auth = storage.getItem('auth');

    if (query.token && query.expiration_date) {
      rankLoginActions
        .validateToken(query.token, runName)
        .then(response => {
          if (response.status === 200) {
            this.props.rankLoginActions.loginUserSuccess(query, query.viewAs === 'emulate');
            this.props.studentActions
              .getStudent()
              .then(response => {
                if (response.user.email) storage.setItem('email', response.user.email);
                browserHistory.push('/rank/' + runName + '/start');
              })
              .catch(() => {
                this.setState({ error: 'Check your credentials please' });
              });
          }
        })
        .catch(() => {
          this.setState({ error: 'Check your credentials please' });
        });
    }
    if (auth && runName) {
      this.props.router.push('/rank/' + runName + '/start');
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.form != this.props.form) {
      if (nextProps.form.login && nextProps.form.login.values && nextProps.form.login.values.email) {
        this.setState({ initialEmail: nextProps.form.login.values.email });
      }
    }
  }

  login = values => {
    this.setState({ inProgress: true });
    let email = values.email.toLowerCase();
    let auth = {
      email,
      password: values.loginPassword
    };
    let runName = this.props.runName;
    this.props.rankLoginActions.loginRank(runName, auth).then(
      () => {
        localStorage.setItem('email', values.email);
        this.props.studentActions.getStudent();
        browserHistory.push('/rank/' + runName + '/start');
      },
      () => {
        this.setState({ inProgress: false });
        this.setState({ error: 'Check your credentials please' });
      }
    );
  };

  openForgotPassModal() {
    this.setState({ showForgotPassModal: true });
  }

  closeForgotPassModal() {
    this.setState({ showForgotPassModal: false });
  }

  onSwitchLoginType = () => {
    this.setState({ useSamlLogin: false, error: null });
  };

  onLoginButtonPressed = runSlug => {
    const redirectUrl = `${config.baseUrl}/runs/${runSlug}/saml-login/`;
    this.setState({ redirecting: true });
    setTimeout(() => {
      window.location = redirectUrl;
    }, 2000);
  };

  render() {
    const { run } = this.props;
    const { useSamlLogin, redirecting } = this.state;
    return (
      <div>
        <Row>
          <Col md={12}>
            <div className="page-subtitle">Student Log In</div>
            <div className="login-form relative">
              {run.saml && useSamlLogin ? (
                <div className="samlLoginContainer">
                  <p>{label.ssoNote}</p>
                  <p>
                    <Button
                      className="cta-button-big"
                      onClick={!redirecting ? () => this.onLoginButtonPressed(run.slug) : null}
                      disabled={redirecting}
                    >
                      {redirecting ? (
                        'Redirecting...'
                      ) : (
                        <span>
                          Login Now <Glyphicon glyph="log-in" />
                        </span>
                      )}
                    </Button>
                  </p>
                  <p className="caption">
                    <button className="plain-button inline" onClick={() => this.onSwitchLoginType()}>
                      Click here
                    </button>
                    if your administrator has instructed you to log in with your email address and Cognomos account
                    password instead.
                  </p>
                  {this.state.error && <span className="text-danger absolute">{this.state.error}</span>}
                </div>
              ) : (
                <div>
                  <LoginForm inProgress={this.state.inProgress} onSubmit={this.login} />
                  <div
                    href=""
                    className="forgot-password-label"
                    onClick={() => {
                      this.openForgotPassModal();
                    }}
                  >
                    Forgot Password
                  </div>
                  {this.state.error && <span className="text-danger absolute">{this.state.error}</span>}
                </div>
              )}
            </div>
          </Col>
        </Row>

        <ForgotPasswordModal
          closeModal={this.closeForgotPassModal}
          showModal={this.state.showForgotPassModal}
          initialValue={this.state.initialEmail}
        />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  let runName = ownProps.params.runName;

  localStorage.setItem('run', runName);
  sessionStorage.setItem('run', runName);
  return {
    runName: runName,
    isAuthenticated: state.login.isAuthenticated,
    form: state.form,
    student: state.student,
    run: state.run
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(loginActions, dispatch),
    rankLoginActions: bindActionCreators(rankLoginActions, dispatch),
    studentActions: bindActionCreators(studentActions, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StudentLoginPage);



// WEBPACK FOOTER //
// ./src/components/login/StudentLoginPage.js